import {
  Autocomplete,
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import { DragUser } from "./DragUser";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  groupAddUsers,
  selectMembers,
} from "../../features/daoTrang/daoTrangSlice";
import { Popup } from "../dialog/Popup";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import { Content } from "../Content/Content";
import * as dayjs from "dayjs";
import { stringAvatar } from "../To/UserChip";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import DoneIcon from '@mui/icons-material/Done';
export function SubGroupCard({ container, isOver }) {
  console.log(container);
  const { members, name, lst } = container;
  const users = useAppSelector(selectMembers);
  const dispatch = useAppDispatch();
  const [checked, setChecked] = useState({});
  const [keys, setKeys] = useState([]);

  function addUserToSubGroup() {
    var slected = Object.keys(checked).filter((key) => checked[key]);
    // candidates.forEach((u, i) => {
    //   if (checked[u.email]) {
    //     slected.push(u.email);
    //   }
    // });
    dispatch(groupAddUsers({ container, lst: slected }));

    // clear selected
    setChecked({});
  }

  function onCheck(key) {
    setChecked({ ...checked, [key]: !checked[key] });
  }

  // const handleChange = (event, keys) => {
  //   console.log(keys);
  //   if (keys.length > 0) {
  //     var newLst = lst.filter((u) => {
  //       for(var key of keys){
  //         if (u.email.includes(key)) return true;
  //       }
  //       return false;
  //     });
  //     setcandidates(newLst);
  //   } else {
  //     setcandidates(lst);
  //   }
  // };
  const AddUserDialog = ({ lst }) => {
    console.log("AddUserDialog", lst);
    var renderLst = lst;
    if (keys.length > 0) {
      renderLst = lst.filter((u) => {
        for (var key of keys) {
          if (u.email.includes(key)) return true;
        }
        return false;
      });
    }
    const searchBar = (
      <Autocomplete
        size="small"
        sx={{ minWidth: 300 }}
        multiple
        value={keys}
        id="tags-outlined"
        options={lst.map((u) => u.email)}
        freeSolo
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              size="small"
              variant="outlined"
              label={typeof option === "object" ? option.txt : option}
              {...getTagProps({ index })}
            />
          ))
        }
        renderInput={(params) => (
          <TextField {...params} label="Account" placeholder="Search" />
        )}
        onChange={(e, v) => setKeys(v)}
      />
    );

    const handleDelete = (user) => onCheck(user.email);
    return (
      <Content searchBar={searchBar}>
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          
          flexWrap="wrap"
          justifyContent="center"
        >
          {renderLst.map((user, i) => {
            const avatar = <Avatar {...stringAvatar(user.name)}></Avatar>;
            const icon = checked[user.email] ? (
              <DoneIcon />
            ) : (
              <CheckBoxOutlineBlankIcon />
            );
            return (
              <Box sx={{ width: 200 }}>
              <Chip
                key={i}
                sx={{
                  height: "auto",
                  "& .MuiChip-label": {
                    display: "block",
                    whiteSpace: "normal",
                  },
                }}
                deleteIcon={icon}
                onDelete={() => handleDelete(user)}
                avatar={avatar}
                label={user.name + " - " + dayjs(user.birth).format("YYYY") + " - " + getAddr(user.address)}
              />
              </Box>
            );
          })}
        </Stack>
      </Content>
    );
  };

  const [isOpen, showPopup] = useState(false);
  const handleAdd = () => {
    showPopup(true);
  };

  return (
    <Card sx={{ minWidth: 275, maxWidth: 275, position: "relative" }}>
      <CardHeader
        title={name}
        action={
          <IconButton onClick={() => handleAdd(container)}>
            <AddIcon color="success" />
          </IconButton>
        }
      ></CardHeader>
      <CardContent>
        <Stack
          spacing={1}
          direction={"row"}
          
          flexWrap={"wrap"}
          sx={{
            overflow: "auto",
            // maxHeight: 300,
          }}
        >
          {members.map((userEmail, i) => {
            var user = users.find((u) => u.email === userEmail);
            if (user) {
              return (
                <div key={i} style={{ margin: "0.3rem 0" }}>
                  <DragUser user={user} container={container}></DragUser>
                </div>
              );
            }
            return <></>;
          })}
        </Stack>
        {/* <AddUserDialog/> */}
        <Popup
          onClose={() => showPopup(false)}
          init={isOpen}
          onOk={addUserToSubGroup}
          title="Select user"
          content={<AddUserDialog lst={lst} />}
        ></Popup>
      </CardContent>
    </Card>
  );
  function getAddr(addr) {
    var arr = addr.split(/[ -]/,1);
    return arr[0];
  }
}
